import React from 'react'

type Props = {
  children: React.ReactNode | React.ReactNode[]
}
const BackgroundWrapper: React.FC<Props> = ({ children }) => {
  return (
    <div className='relative bg-gray-300'>
      {children}
    </div>
  )
}

export default BackgroundWrapper
